enum Packets {
    Handshake,
    Login,
    Welcome,
    Map,
    Spawn,
    List,
    Who,
    Equipment,
    Ready,
    Sync,
    Movement,
    Teleport,
    Despawn,
    Target,
    Combat,
    Animation,
    Points,
    Network,
    Chat,
    Command,
    Container,
    Ability,
    Quest,
    Achievement,
    Notification,
    Blink,
    Heal,
    Experience,
    Death,
    Music,
    NPC,
    Respawn,
    Trade,
    Enchant,
    Guild,
    Pointer,
    PVP,
    Poison,
    Warp,
    Store,
    Overlay,
    Camera,
    Bubble,
    Skill,
    Update,
    Minigame,
    Effect,
    Friends,
    Focus,
    Rank,
    Examine,
    Player,
    Relay,
    Crafting,
    Party,
    CoinRanking,
    CTFChallenge,
    PlayerShop,
    PetAbility,
    Cutscene
}

export default Packets;
